// Angular
import { Component, EventEmitter, HostBinding, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Models
import { AppCleanup } from '../../models';

@Component({
  selector: 'dynamic-edit-form',
  templateUrl: './dynamic-edit-form.component.html',
  styleUrls: ['./dynamic-edit-form.component.scss'],
})
export class DynamicEditFormComponent extends AppCleanup implements OnChanges, OnDestroy {
  @HostBinding('class') classes = 'component-container';
  @Input() form: FormGroup;
  @Input() editingForm: boolean;
  @Input() showEdit: boolean = true;
  @Output() onFormSave: EventEmitter<boolean> = new EventEmitter();
  @Output() onFormEdit: EventEmitter<boolean> = new EventEmitter();
  @Output() onFormReset: EventEmitter<boolean> = new EventEmitter();

  constructor() {
    super();
  }

  ngOnChanges() {
    this.checkFormAccess();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  formButtonClicked(action: string) {
    if (action === 'save' && !this.form.valid) {
      return;
    }

    if (action === 'edit') {
      this.editingForm = true;
      this.onFormEdit.emit(true);
    } else {
      this.editingForm = false;
      this.onFormEdit.emit(false);
    }

    if (action === 'save') {
      this.onFormSave.emit(true);
    } else if (action === 'refresh') {
      this.onFormReset.emit(true);
    }

    this.checkFormAccess();
  }

  checkFormAccess() {
    if (!this.editingForm) {
      this.form?.disable();
    } else {
      this.form?.enable();
    }
  }
}
